import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabbookinginpune() {



    const cardData = {

keyword: "Cab Booking in Pune",

headingDescription:
    "Rising Cab Service provides fast, safe, and reliable Cab Booking in Pune for local travel, airport transfers, railway station pickups, and outstation journeys. We offer easy online and offline booking options with a wide range of vehicles including Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury cars. With professional drivers, 24/7 availability, transparent pricing, and doorstep pickup, we ensure a smooth and comfortable travel experience for all types of passengers including families, corporate clients, and tourists.",

topPlaces: [
    {
        title: "Ganpatipule",
        description:
            " is a serene coastal town known for its pristine beach and the famous Swayambhu Ganpati Temple. It offers peaceful sea views, clean shores, and a calm spiritual atmosphere ideal for relaxing vacations."
    },
    {
        title: "Tarkarli",
        description:
            " is famous for crystal-clear waters, white sand beaches, and thrilling scuba diving and snorkeling experiences. It is one of the best destinations in Maharashtra for marine adventure tourism."
    },
    {
        title: "Ratnagiri",
        description:
            " is a coastal city known for beaches, mango orchards (Alphonso mangoes), historic forts, and scenic sea cliffs along the Konkan coast."
    },
    {
        title: "Sindhudurg Fort",
        description:
            " is a historic sea fort built by Chhatrapati Shivaji Maharaj, located on an island off the Malvan coast. It is known for its architecture, history, and sea views."
    },
    {
        title: "Dapoli",
        description:
            " is a coastal hill station offering beaches, coconut groves, and dolphin-spotting experiences. It combines sea views with a cooler climate, making it a unique Konkan getaway."
    },
    {
        title: "Alibaug",
        description:
            " is a popular beach destination near Mumbai known for forts, clean beaches, ferry rides, and weekend relaxation with seafood and sunset views."
    },
    {
        title: "Kolhapur",
        description:
            " is a cultural city famous for the Mahalaxmi Temple, Kolhapuri cuisine, leather footwear, and rich Maratha heritage and history."
    },
    {
        title: "Amboli",
        description:
            " is a monsoon hill station in the Sahyadri range known for waterfalls, misty forests, biodiversity, and cool weather, making it a hidden gem in Maharashtra."
    },
    {
        title: "Malvan",
        description:
            " is a coastal town famous for Tarkarli beach nearby, scuba diving, Sindhudurg Fort access, and delicious Malvani seafood cuisine."
    },
    {
        title: "Bhandardara",
        description:
            " is a peaceful lakeside village surrounded by mountains, waterfalls, and Arthur Lake. It is ideal for camping, stargazing, and nature retreats away from city life."
    }
],



services: [
{
name: "Pune Cab Booking",
description: "Rising Cab Service offers Pune Cab Booking for fast, reliable, and comfortable travel across the city and beyond. Book well-maintained AC Sedans, SUVs, Innova Crysta, Kia Carens, and Tempo Traveller with professional drivers, doorstep pickup, and 24x7 availability for local, airport, and outstation travel needs."
},
{
name: "Online Cab Booking Pune",
description: "Book Online Cab Booking Pune with Rising Cab Service for instant confirmation, easy reservation, and transparent pricing. Choose from multiple vehicle options and enjoy smooth travel for city rides, airport transfers, and long-distance journeys."
},
{
name: "Cab Booking App Pune",
description: "Our Cab Booking App Pune service ensures quick and hassle-free cab reservations with real-time availability, easy booking process, and reliable driver allocation for all types of travel requirements."
},
{
name: "Instant Cab Booking Pune",
description: "Rising Cab Service provides Instant Cab Booking Pune for immediate ride confirmation and quick pickup anywhere in Pune. Ideal for urgent travel, meetings, airport drops, and last-minute plans."
},
{
name: "Book Cab Pune",
description: "Use Book Cab Pune service for simple and convenient cab reservation with flexible travel options, clean vehicles, and professional drivers for safe and comfortable journeys."
},
{
name: "Pune Cab Reservation",
description: "Our Pune Cab Reservation service allows advance booking for local and outstation trips with guaranteed availability, fixed pricing, and reliable travel support for families and professionals."
},
{
name: "Taxi Booking Pune Online",
description: "Book Taxi Booking Pune Online with Rising Cab Service for secure, fast, and transparent cab booking. Enjoy easy payment options and confirmed rides within minutes."
},
{
name: "Local Cab Booking Pune",
description: "Rising Cab Service offers Local Cab Booking Pune for daily commuting, shopping, meetings, and short-distance travel with affordable fares and quick response time."
},
{
name: "Outstation Cab Booking Pune",
description: "Our Outstation Cab Booking Pune service provides safe and comfortable intercity travel to Mumbai, Goa, Nashik, Shirdi, Mahabaleshwar, and more with experienced drivers and well-maintained vehicles."
},
{
name: "Cab Hire Pune",
description: "Book Cab Hire Pune for flexible travel options including hourly rental, full-day booking, and customized travel plans with AC cars and professional chauffeurs."
},
{
name: "Best Cab Booking Pune",
description: "Rising Cab Service offers Best Cab Booking Pune with reliable service, verified drivers, clean vehicles, and 24x7 availability for all travel needs."
},
{
name: "Cab Booking Near Me Pune",
description: "Our Cab Booking Near Me Pune service ensures quick pickup from your location anywhere in Pune with fast response and easy booking support."
},
{
name: "Affordable Cab Booking Pune",
description: "Book Affordable Cab Booking Pune for budget-friendly travel without compromising comfort and safety. Ideal for daily travel, airport transfers, and outstation trips."
},
{
name: "Pune Cab Hire Service",
description: "Rising Cab Service provides Pune Cab Hire Service for local and long-distance travel with flexible packages, clean vehicles, and professional drivers."
},
{
name: "Quick Cab Booking Pune",
description: "Our Quick Cab Booking Pune service ensures instant ride confirmation and fast pickup for urgent travel needs across Pune city."
},
{
name: "24x7 Cab Booking Pune",
description: "Rising Cab Service offers 24x7 Cab Booking Pune for round-the-clock availability, ensuring safe and reliable transportation anytime you need."
},
{
name: "Airport Cab Booking Pune",
description: "Book Airport Cab Booking Pune for timely pickups and drops to Pune Airport with comfortable vehicles and professional drivers ensuring stress-free travel."
},
{
name: "One Way Cab Booking Pune",
description: "Our One Way Cab Booking Pune service is perfect for drop-only intercity travel with affordable pricing and flexible pickup locations."
},
{
name: "Pune Railway Station Cab Booking",
description: "Rising Cab Service provides Pune Railway Station Cab Booking for quick pickup and drop services with reliable drivers and comfortable rides."
},
{
name: "Corporate Cab Booking Pune",
description: "Book Corporate Cab Booking Pune for employee transportation, office travel, and business trips with professional service and punctual drivers."
},
{
name: "Round Trip Cab Booking Service",
description: "Our Round Trip Cab Booking Service offers convenient return travel with waiting options, flexible scheduling, and cost-effective packages."
},
{
name: "Outstation Round Trip Cab",
description: "Rising Cab Service provides Outstation Round Trip Cab for long-distance journeys with safe driving, comfortable vehicles, and reliable return trips."
}
],

tableData: [
["Pune Cab Booking","Online Cab Booking Pune"],
["Cab Booking App Pune","Instant Cab Booking Pune"],
["Book Cab Pune","Pune Cab Reservation"],
["Taxi Booking Pune Online","Local Cab Booking Pune"],
["Outstation Cab Booking Pune","Cab Hire Pune"],
["Best Cab Booking Pune","Cab Booking Near Me Pune"],
["Affordable Cab Booking Pune","Pune Cab Hire Service"],
["Quick Cab Booking Pune","24x7 Cab Booking Pune"],
["Airport Cab Booking Pune","One Way Cab Booking Pune"],
["Pune Railway Station Cab Booking","Corporate Cab Booking Pune"],
["Round Trip Cab Booking Service","Outstation Round Trip Cab"]
],



whychoose: [
    {
        WhyChooseheading: "Trusted Cab Booking in Pune",
        WhyChoosedescription: "Rising Cab Service offers dependable cab booking solutions across Pune with professional drivers, clean vehicles, and customer-friendly travel services."
    },
    {
        WhyChooseheading: "24/7 Transportation Availability",
        WhyChoosedescription: "Whether it's an early morning airport transfer, late-night pickup, office commute, or emergency travel requirement, our cab services are available throughout the day."
    },
    {
        WhyChooseheading: "Suitable for Local and Outstation Travel",
        WhyChoosedescription: "From city rides and airport transfers to outstation tours, pilgrimage trips, and corporate travel, we provide transportation for every journey."
    },
    {
        WhyChooseheading: "Fleet Options for Every Requirement",
        WhyChoosedescription: "Customers can select Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to their needs."
    },
    {
        WhyChooseheading: "Affordable and Transparent Pricing",
        WhyChoosedescription: "Our cab booking services focus on fair pricing, flexible travel plans, and complete transparency for customers."
    },
    {
        WhyChooseheading: "Pickup Service Across Pune & PCMC",
        WhyChoosedescription: "We provide pickup facilities from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, Pune Airport, and all major locations."
    },
    {
        WhyChooseheading: "Comfortable Travel for Every Passenger",
        WhyChoosedescription: "Our vehicles are maintained regularly to ensure cleanliness, comfort, safety, and a pleasant travel experience."
    },
    {
        WhyChooseheading: "Preferred Choice for Families and Businesses",
        WhyChoosedescription: "Rising Cab Service caters to families, tourists, corporate employees, students, senior citizens, and daily commuters across Pune."
    }
]
};

const faqData = [
    {
        question: "What services are included under Cab Booking in Pune?",
        answer: "Cab booking services include local travel, airport transfers, railway station pickups, outstation trips, sightseeing tours, corporate transportation, and one-way travel."
    },
    {
        question: "Can customers reserve cabs at any time of the day?",
        answer: "Yes, transportation services are available round the clock for local and outstation travel requirements."
    },
    {
        question: "Which vehicle options are available for booking?",
        answer: "Customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
    },
    {
        question: "Do you provide airport pickup and drop services in Pune?",
        answer: "Yes, convenient airport transportation services are available for Pune Airport and nearby airport destinations."
    },
    {
        question: "Can I hire a cab for outstation travel from Pune?",
        answer: "Yes, outstation cabs are available for destinations across Maharashtra and various cities throughout India."
    },
    {
        question: "Are cabs available for corporate employees and business travel?",
        answer: "Yes, many organizations and professionals use our transportation services for meetings, events, employee travel, and corporate requirements."
    },
    {
        question: "Can larger groups hire Tempo Travellers and Mini Buses?",
        answer: "Yes, group transportation options are available for family functions, tours, events, and corporate outings."
    },
    {
        question: "Do you provide pickup services from Pune Railway Station?",
        answer: "Yes, passengers can schedule pickups and drop-offs from Pune Railway Station and nearby railway terminals."
    },
    {
        question: "Can customers make advance cab reservations?",
        answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak travel seasons."
    },
    {
        question: "How can I book a cab in Pune?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Nikhil Patwardhan",
        feedback:
            "Finding a reliable cab in Pune became effortless with Rising Cab Service. The vehicle arrived on time, and the overall travel experience was smooth and comfortable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Rutuja Jagtap",
        feedback:
            "From airport transfers to outstation journeys, every trip has been managed professionally. The service quality and customer support have always been excellent.",
        rating: 5
    }
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Booking in Pune",
"image": "https://www.risingcabservice.com/assets/images/cab-booking-pune.jpg",
"description": "Book reliable Cab Booking in Pune with Rising Cab Service for local and outstation travel. Get instant cab booking, affordable fares, and comfortable AC sedans, SUVs, and Innova cars with professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-booking-in-pune"
}
};








    return (
        <div>

<Helmet>
  <title>Cab Booking in Pune | Online Taxi Booking | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Booking in Pune instantly with Rising Cab Service. Get affordable local and outstation taxi booking with AC sedans, SUVs, and Innova cars at best prices."
/>

<meta
 name="keywords"
 content="Pune Cab Booking, pune cab booking, online cab booking pune, cab booking app pune, instant cab booking pune, book cab pune, pune cab reservation, taxi booking pune online, local cab booking pune, outstation cab booking pune, cab hire pune, best cab booking pune, cab booking near me pune, affordable cab booking pune, pune cab hire service, quick cab booking pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/61.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabbookinginpune;